import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { initProductOptions } from '../../selectors/ProductOptionsSelector';
import { selectInventoryWrapper } from '../../selectors/PdpNameSpaceSelector';
import * as styles from './OOSMessage.css';

const cx = classNames.bind(styles);

export class OOSMessage extends Component {
    static defaultProps = {
        inventory: [],
        displayPrimaryOOSMessage: true,
        productOptions: {},
    };

    static propTypes = {
        inventory: PropTypes.array,
        displayPrimaryOOSMessage: PropTypes.bool,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    oosMessage() {
        /* istanbul ignore next */
        return (
            <div
                className={cx(
                    'oos-message-container',
                    'text-urgency',
                    dt(['text-urgency-border', 'mt-4'])
                )}
            >
                <Icon
                    className={cx('svg-icon')}
                    iconType="svg"
                    width="20px"
                    height="20px"
                    viewBox="0 2 40 40"
                >
                    <Warning />
                </Icon>
                <span className={cx('oos-message')}>This Item is Out of Stock</span>
            </div>
        );
    }

    render() {
        const {
            productOptions: { isProductInStock },
            inventory,
            displayPrimaryOOSMessage,
        } = this.props;
        return (
            <div>
                {displayPrimaryOOSMessage &&
                !isProductInStock &&
                isProductInStock !== '' &&
                inventory[0] &&
                inventory[0].inventory
                    ? this.oosMessage()
                    : ''}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    inventory: selectInventoryWrapper(ownProps.fromMiniPDP)(state),
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
});

export default connect(mapStateToProps)(OOSMessage);
